/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import { Container } from '@mui/material';
import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardText, Button, Image, Form, CardTitle } from 'react-bootstrap';
import jwt_decode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import SparkApi from '../api/SparkApi';
import { ToastContainer , toast } from 'react-toastify';
import { usePermission } from './context/PermissionContext';

const MyProfile = () => {
    const navigate = useNavigate();
    // const [userinfo, setUserInfo] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const {setUserInfo , permissionData, userInfo} = usePermission();

    console.log('permissionData-->',permissionData);

    const can_create = permissionData?.My_Profile?.can_create;
    const can_edit = permissionData?.My_Profile?.can_edit;
    //const can_delete = permissionData?.My_Profile?.can_delete;


    useEffect(() => {
        if (!sessionStorage.getItem("token")) {
            navigate("/login");
        }
        if (sessionStorage.getItem("notifications") && JSON.parse(sessionStorage.getItem("notifications")).length > 0) {
            navigate("/maintenance");
        }

        try {
            const decodedToken = jwt_decode(sessionStorage.getItem('token'));
            
            setUserInfo(decodedToken);
        } catch (error) {
            console.error("Error decoding token", error);
        }
    }, [navigate]);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (e.target.name === "phone") {
            const isValid = /^\d{0,10}$/.test(value);
            if (isValid) {
                setUserInfo((prev) => ({ ...prev, [name]: value }));
            }
        } else {
            setUserInfo((prev) => ({ ...prev, [name]: value }));
        }
    };

    const toggleEditMode = async () => {
        try {
            if (isEditing && (userInfo?.firstname.trim() === "" || userInfo?.lastname.trim() === "" || userInfo?.phone.trim() === "")) {
                return toast.error("Missing required field")
            }

            if (isEditing) {
                const profileResult = await SparkApi.updateUserProfile(userInfo , userInfo.id);
                
                if (profileResult?.success) {
                    sessionStorage.removeItem("token");
                    sessionStorage.setItem("token", profileResult.authToken);
                    toast.success(profileResult.message);
                    setUserInfo(userInfo)
                }
            }
            setIsEditing(!isEditing);
        } catch (error) {
           console.log('Server error: ' , error);
        }
    };

    if (!userInfo) return <div>Loading...</div>;

    return (
        <>
            <Container>
                <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <Row className="justify-content-center mt-3">
                    <Col lg={6}>
                        <Card className="text-center">
                            <Card.Header as="h4" className="text-start fw-bold">Profile</Card.Header>
                            <Card.Body>
                                <Image
                                    src={"/srmlogo.jpg"}
                                    roundedCircle
                                    fluid
                                    style={{ width: '150px', height: '150px', marginBottom: '15px' }}
                                />

                                {isEditing ? (
                                    <Form>
                                        <Row className='mb-3'>
                                            <Col lg={6} xs={6}>
                                                <Form.Group controlId="formName">
                                                    <Form.Label className='d-flex justify-conent-start'>First Name</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="firstname"
                                                        // value={userinfo?.username.split(" ")[0] || ""}
                                                        value={userInfo?.firstname|| ""}
                                                        onChange={handleInputChange}
                                                        placeholder='Enter Name'
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6} xs={6}>
                                                <Form.Group controlId="formName">
                                                    <Form.Label className='d-flex justify-conent-start'>Last Name</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="lastname"
                                                        // value={userInfo?.lastname || userinfo?.username.split(" ").slice(1).join(" ")}
                                                        value={userInfo?.lastname || ""}
                                                        onChange={handleInputChange}
                                                        placeholder='Enter Name'
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6} xs={6}>
                                                <Form.Group controlId="formPhone">
                                                    <Form.Label className='d-flex justify-conent-start'>Phone</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="phone"
                                                        max={10}
                                                        value={userInfo.phone || ""}
                                                        onChange={handleInputChange}
                                                        placeholder='Enter phone number'
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form>
                                ) : (
                                    <>
                                        <CardTitle as="h3">{`${userInfo.firstname} ${userInfo?.lastname}`}</CardTitle>
                                        <CardText className="text-muted"><b>Phone:</b> {userInfo.phone}</CardText>
                                        <CardText><b>Role:</b> {userInfo.userrole}</CardText>
                                        <CardText><strong>Location:</strong> {userInfo.companyname}</CardText>
                                    </>
                                )}
                                {isEditing && <Button variant='danger btn-sm' onClick={() => setIsEditing(!isEditing)}>Cancel</Button>}
                               { (userInfo?.userrole === "ADMIN" || can_edit) && 
 <>                               <Button variant="primary mx-2 btn-sm" onClick={toggleEditMode}>
                                    {isEditing ? 'Save Profile' : 'Edit Profile'}
                                </Button>
                                <Button variant="primary  btn-sm" onClick={() => navigate(`/changepassword/${userInfo.id}`)}>
                                    Change Password
                                </Button>
                                </>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default MyProfile;